// extracted by mini-css-extract-plugin
module.exports = {"large":"only screen and (min-width: 992px)","pills":"_24TcJ","pill":"_7NiKl"};